<template>
	<div>
		<div class="" style="position: relative;width:100%;height: 100%;">
			<div id="lsfzEcharts1" style="width:100%;height:100%;"></div>
		</div>

	</div>
</template>

<script>
	import * as echarts from 'echarts'
	import 'echarts-gl'
	export default {
		data() {
			return {
				data: [],
				myChart: ''
			}
		},
		mounted() {
			this.$request('/center/home/rightOne').then(res => {
				this.init(res.data.list);
			})
		},
		methods: {
			init(pageData) {
				let that = this
				this.myChart = echarts.init(document.getElementById("lsfzEcharts1"), "purple-passion");
				//随着屏幕大小调节图表
				window.addEventListener("resize", () => {
					that.myChart.resize();
				});
				var option = {
					title: {
						text: '人才年龄分布',
						left: '44%',
						top: '37%',
						width: 10,
						textStyle: {
							color: '#fff',
							width: 60,
							overflow: 'break',
							fontSize: 14
						},
						textAlign: 'center',
					},
					color: ['#1890FF', '#12DDA1', '#F78048', '#FFB026', '#FD4D63', 'rgba(255,255,255,.5)'],
					tooltip: {
						trigger: 'item',
						padding: [10, 10, 10, 10],
						formatter: '{b} :<br/> {c}万人',
					},
					series: [{
							name: '',
							type: 'pie',
							radius: ['57%', '87%'],
							center: ['50%', '50%'],
							label: {
								fontSize: 10,
								color: '#fff',
								position: 'inside',
								formatter: function(param) {
									return param.name;
								},
							},
							labelLine: {
								show: false,
								// length: 6,
								// length2: 15
							},
							data: [{
									name: '18-25岁',
									value: '297.5',
								},
								{
									name: '26-35岁',
									value: '340',
								},
								{
									name: '36-45岁',
									value: '153',
								},
								{
									name: '46岁以上',
									value: '59.5',
								}
							],
						},
						{
							type: 'pie',
							radius: ['56%', '65%'],
							center: ['50%', '50%'],
							silent: true,
							data: [{
								name: '',
								value: 1,
							}, ],
						},
					],
				};


				this.myChart.setOption(option);

				setInterval(function() {
					that.myChart.clear()
					that.myChart.setOption(option);
				}, 15000)
			}
		}
	}
</script>

<style scoped>
	.sycw {
		font-size: 72rpx;
		font-family: DingTalk JinBuTi, DingTalk JinBuTi;
		font-weight: 900;
		color: #FFFFFF;
		text-shadow: 0px 8rpx 20rpx rgba(0, 0, 0, 0.8);
		-webkit-background-clip: text;
		-webkit-text-fill-color: #ffedf6;
	}

	.title {
		font-size: 24rpx;
		font-family: Source Han Sans, Source Han Sans;
		font-weight: 400;
		color: #dbecff;
		line-height: 40px;
		margin-left: 20rpx;
	}

	.bg {
		width: 30rpx;
		height: 30rpx;

	}
</style>